import React, { Component } from 'react'

class Loader extends Component {
    render() {
        return (
            <div id="loader" className={'loader justify-content-center ' + (this.props.hide ? 'hide' : '')}>
                <div className="maxui-roller align-self-center">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        )
    }
}

export default Loader